import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { StreamCall, StreamTheme } from "@stream-io/video-react-sdk";
import { useGetCallById } from "../../../hooks/useGetCallById";
import Loader from "../../../components/Live/Loader";
import LiveSetup from "../../../components/Live/LiveSetup";
import LiveRoom from "../../../components/Live/LiveRoom";

const Live = () => {
  const { id } = useParams<{ id: string }>();
  const { call, isCallLoading } = useGetCallById(id || "");
  const [isSetupComplete, setIsSetupComplete] = useState(false);

  useEffect(() => {
    const cleanup = async () => {
      if (call) {
        await call.camera?.disable();
        await call.microphone?.disable();
        await call.screenShare?.disable();
      }
    };

    return () => {
      cleanup();
    };
  }, [call]);

  if (isCallLoading)
    return (
      <div
        className={`flex justify-center items-center`}
        // className={`Page PagePreview flex justify-center items-center`}
        id="content"
      >
        <Loader />
      </div>
    );

  return (
    <StreamCall call={call}>
      <StreamTheme>
        {!isSetupComplete ? (
          <LiveSetup setIsSetupComplete={setIsSetupComplete} />
        ) : (
          <LiveRoom />
        )}
      </StreamTheme>
    </StreamCall>
  );
};

export default Live;
